import type { FC } from 'react'
import { Box, HStack, Link as ChakraLink, Text, VStack } from '@chakra-ui/react'
import Link from 'next/link'
import Image from 'next/image'
import { ContentContainer } from 'ui'
import granditudeLogoLight from '../../images/granditude_logo_light.svg'

const footerLinks = [
  { id: 'what-we-do', label: 'What We Do', path: '/what-we-do' },
  { id: 'partners', label: 'Partners & Integrations', path: '/partners' },
  { id: 'working-together', label: 'Working Together', path: '/working-together' }
]

const CustomFooter: FC = () => {
  return (
    <Box
      as="footer"
      w="100%"
      bg="background.dark"
      color="white"
      borderTopWidth={1}
      borderTopColor="border.dark"
      borderTopStyle="solid"
    >
      <ContentContainer
        py={{ base: 10, md: 16 }}
        direction={{ base: 'column', md: 'row' }}
        justify="space-between"
        align={{ base: 'center', md: 'center' }}
        gap={{ base: 8, md: 0 }}
      >
        {/* Logo */}
        <Link href="/">
          <Image src={granditudeLogoLight} alt="Granditude" height={30} priority />
        </Link>

        {/* Navigation links */}
        <HStack gap="1rem 2rem" flexWrap="wrap" justifyContent="center">
          {footerLinks.map((link) => (
            <Link key={link.id} href={link.path}>
              <Text
                fontSize="0.9rem"
                color="whiteAlpha.600"
                transition="color 0.2s ease"
                _hover={{ color: 'white' }}
              >
                {link.label}
              </Text>
            </Link>
          ))}
        </HStack>

        {/* Contact info */}
        <VStack spacing={0} align={{ base: 'center', md: 'flex-end' }}>
          <ChakraLink
            href="mailto:info@granditude.com"
            fontSize="0.9rem"
            color="whiteAlpha.800"
            _hover={{ color: 'white' }}
          >
            info@granditude.com
          </ChakraLink>
          <Text fontSize="0.9rem" color="whiteAlpha.600">
            +46 (0)70 840 69 51 · Stockholm
          </Text>
        </VStack>
      </ContentContainer>
    </Box>
  )
}

export default CustomFooter
